module.exports = __webpack_public_path__ + "img/alef.920b5019.jpg";